// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"CustomScroll_custom-scroll__UjWPh","custom-scroll__button":"CustomScroll_custom-scroll__button__YHDlR","disabled":"CustomScroll_disabled__b_2S8"};